import { createStructuredSelector } from 'reselect';
import {
  searchConfigSelector,
  searchResultConfigSelector,
  propertySelector,
  propertyListSelector,
  formSelector,
  queryStringSelector,
  officeSelector,
  clientConfigSelector,
  importStatusSelector
} from '../../selectors/global';

export default createStructuredSelector({
  formData: formSelector,
  property: propertySelector,
  propertyList: propertyListSelector,
  queryString: queryStringSelector,
  searchConfig: searchConfigSelector,
  clientConfig: clientConfigSelector,
  searchResultConfig: searchResultConfigSelector,
  office: officeSelector,
  importStatus: importStatusSelector
});
